import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { BillingPlanTier } from '@core/products-types';
import { RtTooltip, IconComponent, HeadingComponent } from '@core/user-interface-legacy';

import { PlanPickerModel } from '../plan-picker.model';

@Component({
  selector: 'rt-plan-picker-compare',
  templateUrl: './plan-picker-compare.component.html',
  styleUrls: ['./plan-picker-compare.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HeadingComponent, IconComponent, RtTooltip, TranslatePipe],
})
export class PlanPickerCompareComponent {
  @Input() public highlighted: BillingPlanTier;
  @Input() public active: BillingPlanTier | string;

  public BillingPlanTier = BillingPlanTier;

  constructor(public content: PlanPickerModel) {}

  public trackByIndex(index: number) {
    return index;
  }
}
